// AbDocumentsPage — "Dokumente"-Sub-View der AbShell: Upload-Dropzone (Toggle) + Dokumentenliste
// mit den neuen Filtern (AbDocumentList). Ersetzt den bisherigen KPI+Upload+Liste-Block aus
// AuftragsbestaetigungView.js (KPI-Kacheln leben jetzt im Dashboard, hier bewusst weggelassen -
// Bauplan: "KPI-Kacheln klein optional weglassen — Dashboard hat sie").
// initialFilter (aus einem Dashboard-KPI-Klick): { tab?, status?, committed?, openUpload? } | null.

import React, { useMemo, useState } from 'react';
import { Upload, X } from 'lucide-react';
import { btnGhost } from './ui';
import AbUpload from './AbUpload';
import AbDocumentList from './AbDocumentList';

const AbDocumentsPage = ({ user, isDarkMode, t, onOpenDocument, showSuccess, showError, initialFilter }) => {
  const [showUpload, setShowUpload] = useState(!!initialFilter?.openUpload);

  // Remount-Key: bei jedem NEUEN Filter-Objekt (Dashboard-KPI-Klick) die Liste frisch initialisieren
  // (Muster: bisheriges key={listTab} in AuftragsbestaetigungView.js / LagerShell pendingFilter).
  const listKey = useMemo(() => JSON.stringify(initialFilter || {}), [initialFilter]);

  const onUploaded = (id) => onOpenDocument(id);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className={`text-lg font-bold ${isDarkMode ? 'text-white/90' : 'text-slate-900'}`}>{t('ab.shell.documentsTitle')}</h2>
          <p className={`text-xs mt-0.5 ${isDarkMode ? 'text-white/50' : 'text-slate-500'}`}>{t('ab.shell.documentsSubtitle')}</p>
        </div>
        <button type="button" onClick={() => setShowUpload((s) => !s)} className={btnGhost(isDarkMode)}>
          <span className="flex items-center gap-2">
            {showUpload ? <X className="w-4 h-4" /> : <Upload className="w-4 h-4" />}
            {showUpload ? t('ab.uploadHide') : t('ab.uploadButton')}
          </span>
        </button>
      </div>

      {showUpload && (
        <AbUpload user={user} isDarkMode={isDarkMode} t={t} onUploaded={onUploaded} showSuccess={showSuccess} showError={showError} />
      )}

      <AbDocumentList
        key={listKey}
        user={user} isDarkMode={isDarkMode} t={t}
        onOpenDocument={onOpenDocument} showError={showError}
        initialTab={initialFilter?.tab || 'open'}
        initialStatusFilter={initialFilter?.status || ''}
        initialCommitted={initialFilter?.committed || ''}
      />
    </div>
  );
};

export default AbDocumentsPage;
